import fc from "@/firebaseConfig";
import firebase from "firebase/app";
// import algoliasearch from "algoliasearch";
import getDocumentTypeKey from "../../libs/getDocumentTypeKey";
import router from "@/router";
import gql from "graphql-tag";
import moment from "moment";
const _ = require("lodash");

const sortByField = (arr, field, order) => {
  const multiplier = order === "desc" ? -1 : 1;
  const compareFunction = (a, b) => {
    const aValue = a[field];
    const bValue = b[field];

    if (typeof aValue === "string" && typeof bValue === "string") {
      return multiplier * aValue.localeCompare(bValue);
    }

    return multiplier * (aValue - bValue);
  };

  return [...arr].sort(compareFunction);
};

function isNumeric(input) {
  return /^[0-9]+$/.test(input);
}

// function adjustDate(inputDateString) {
//   const localDate = new Date(inputDateString); // Parse the formatted date string
//   const utcTimestamp = new Date(localDate.getTime() - (7 * 60 * 60 * 1000)); // Adjust for UTC+7
//   return firebase.firestore.Timestamp.fromDate(utcTimestamp);
// }

function getDateBefore(inputDateString) {
  const localDate = new Date(inputDateString); // Parse the formatted date string
  const utcTimestamp = new Date(localDate.getTime() - 7 * 60 * 60 * 1000); // Adjust for UTC+7
  return firebase.firestore.Timestamp.fromDate(utcTimestamp); // Convert to Firestore timestamp
}

function getDateEndPlus100Milliseconds(inputDateString) {
  const localDate = new Date(inputDateString); // Parse the formatted date string
  const utcTimestamp = new Date(
    localDate.getTime() + (24 - 7) * 60 * 60 * 1000 + 100
  ); // Adjust for UTC+7, set to end of the day, and add 100 milliseconds
  return firebase.firestore.Timestamp.fromDate(utcTimestamp); // Convert to Firestore timestamp
}

function getDateBeforeEnd(inputDateString) {
  const localDate = new Date(inputDateString); // Parse the formatted date string
  const utcTimestamp = new Date(
    localDate.getTime() + (36 - 7) * 60 * 60 * 1000
  ); // Adjust for UTC+7, set to end of the day, and add 12 hours
  return firebase.firestore.Timestamp.fromDate(utcTimestamp); // Convert to Firestore timestamp
}

const removeDuplicatesWithSameId = (inputArray) => {
  const idSet = new Set(); // To track encountered IDs
  const resultArray = [];

  for (const item of inputArray) {
    // Assuming each item has an 'id' property
    const itemId = item.id;

    if (!idSet.has(itemId)) {
      // If the ID is not in the set, add it to the result and the set
      idSet.add(itemId);
      resultArray.push(item);
    }
  }

  return resultArray;
};

export default {
  namespaced: true,
  state: {
    list: [],
    listOrigin: [],
    searchField: "orderID",
    page: 1,
    loading: false,
    count: 0,
    keyword: "",
    fromDate: "",
    toDate: "",
    emptyList: true,
    stackPage: {},
    currentPageAlgolia: 0,
    docList: [],
    summaryReport: {},
    orderBySelect: { key: "timeOrderCreated", value: "desc" },
    valueFilterList: ["@DownloadedXml", "not-download"],
    selectedList: [],
    summaryAll: null,
    showPaginationTemplate: true,
    mSaleOrdersDocListUnsubscribeObject: null,
    mSaleOrdersSummaryAllUnsubscribeObject: null,
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setFromDate(state, val) {
      state.fromDate = val;
    },
    setToDate(state, val) {
      state.toDate = val;
    },
    setSearchField(state, val) {
      state.searchField = val;
    },
    setCompaniesDocs(state, val) {
      state.list = removeDuplicatesWithSameId(val);
    },
    setPage(state, val) {
      state.page = val;
    },
    setKeyword(state, val) {
      state.keyword = val;
    },
    setListOrigin(state, val) {
      state.listOrigin = val;
    },
    setEmptyList(state, val) {
      state.emptyList = val;
    },
    setStackPage(state, val) {
      state.stackPage = val;
    },
    setCurrentPageAlgolia(state, val) {
      state.currentPageAlgolia = val;
    },
    setDocList(state, val) {
      state.docList = val;
    },
    setSummaryReport(state, val) {
      state.summaryReport = val;
    },
    setOrderBySelect(state, val) {
      state.orderBySelect = val;
    },
    setValueFilterList(state, val) {
      state.valueFilterList = val;
    },
    setSelectedList(state, val) {
      state.selectedList = val;
    },
    setSummaryAll(state, val) {
      state.summaryAll = val;
    },
    setShowPaginationTemplate(state, val) {
      state.showPaginationTemplate = val;
    },
  },
  actions: {
    updateDocs({ commit }, val) {
      commit("setCompaniesDocs", val);
    },
    getDocumentType() {
      let documentType = router.currentRoute.name.split(".");
      if (documentType.length > 2) {
        return documentType[documentType.length - 1];
      }
      return "";
    },
    setLoading({ commit }, val) {
      commit("setLoading", val);
    },
    setFromDate({ commit }, val) {
      commit("setFromDate", val);
    },
    setToDate({ commit }, val) {
      commit("setToDate", val);
    },
    setSearchField({ commit }, val) {
      commit("setSearchField", val);
    },
    async setDocsData({ commit }, data) {
      if (data && data.length) {
        let pageLimit = localStorage.getItem("pageLimit");
        if (pageLimit === "auto") {
          pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10;
        } else {
          pageLimit = parseInt(pageLimit) || 10;
        }

        let docsList = data;
        let docs = [];
        for (let doc of docsList) {
          doc = doc.node;
          let timeSignedXml = null;
          if (doc.timeSignedXml) {
            timeSignedXml = moment(doc.timeSignedXml);
          }
          console.log("setDoc");
          let d = {
            "@BuyerBranchID": doc.buyerBranchId,
            "@DocType": doc.docType,
            "@DownloadedXml": doc.downloadedXml,
            "ED.IssueDateTime": doc.edIssueDateTime,
            "@Errors": JSON.parse(JSON.parse(doc.errors)),
            // doc.mailSent,
            objectID: doc.objectId,
            "SCTT.AHTA.BTP.ID": doc.scttAhtaBtpId,
            "SCTT.AHTA.BTP.Name": doc.scttAhtaBtpName,
            "SCTT.AHTA.BTP.STR.ID": doc.scttAhtaBtpStrId,
            "SCTT.AHTS.STSHMS.GrandTotalAmount":
              doc.scttAhtsStshmsGrandTotalAmount,
            "SCTT.AHTS.STSHMS.TaxBasisTotalAmount":
              doc.scttAhtsStshmsTaxBasisTotalAmount,
            "SCTT.AHTS.STSHMS.TaxTotalAmount": doc.scttAhtsStshmsTaxTotalAmount,
            "@SignedPdfUrl": doc.signedPdfUrl,
            "@SignedXmlUrl": doc.signedXmlUrl,
            "@TimeSignedXml": timeSignedXml,
            "@UnsignedPdfUrl": doc.unsignedPdfUrl,
          };
          docs.push(d);
        }

        let startVisible = docs[0];
        let lastVisible = docs[docs.length - 1];

        let objectTmp = {
          first: _.cloneDeep(startVisible),
          last: _.cloneDeep(lastVisible),
        };
        let stackPage = _.cloneDeep(this.state.saleorders.stackPage);
        stackPage[this.state.saleorders.page] = objectTmp;

        commit("setStackPage", stackPage);
        commit("setCompaniesDocs", docs);
        commit("setListOrigin", docs);
        commit("setEmptyList", false);
        commit("setLoading", false);
      } else {
        commit("setCompaniesDocs", []);
        commit("setListOrigin", []);
        commit("setEmptyList", true);
      }
    },
    async getList({ rootState, commit, dispatch }, { id, isNextPage }) {
      commit("setLoading", true);
      // console.log("getlist");
      // console.log("this.state.saleorders ==> ", this.state.saleorders);

      // Unsubscribe from any previous real-time listener
      if (this.state.mSaleOrdersDocListUnsubscribeObject) {
        this.state.mSaleOrdersDocListUnsubscribeObject();
        this.state.mSaleOrdersDocListUnsubscribeObject = null;
    }

      let pageLimit = localStorage.getItem("pageLimit");
      if (pageLimit === "auto") {
        pageLimit = parseInt(localStorage.getItem("pageLimitAuto")) || 10;
      } else {
        pageLimit = parseInt(pageLimit) || 10;
      }

      let documentType = await dispatch("getDocumentType");
      let documentTypeNumber = getDocumentTypeKey(documentType);
      let selectedBranch = rootState.companies.selectedBranch;

      let query = fc.companies.doc(id).collection("SaleOrders");
      let { keyword } = this.state.saleorders;

      if (keyword) {
        const _searchField = new firebase.firestore.FieldPath(
          this.state.saleorders.searchField
        );

        /////////////////////

        //////////

        var cleanKeyword = keyword
          .replace(/[,.]/g, "")
          .replace(/\s/g, "")
          .trim();

        let _keyword;
        let _endKey;

        console.log(
          "this.state.saleorders.searchField:: ",
          this.state.saleorders.searchField
        );

        if (
          isNumeric(cleanKeyword) &&
          this.state.saleorders.searchField !== "orderID"
        ) {
          _keyword = Number(cleanKeyword);
          _endKey = _keyword;
          console.log("keyword type number ==> ", typeof _keyword);
          console.log("keyword type number ==> ", _keyword);
        } else {
          _keyword = keyword.trim().toUpperCase();
          _endKey = _keyword + "\uf8ff";
          // console.log("keyword type string ==> ", typeof(_keyword))
          _keyword =
            this.state.docs.searchField == "objectID"
              ? keyword.trim().toUpperCase()
              : keyword.trim();
          _endKey = _keyword + "\uf8ff";
        }
        console.log("_keyword::: ", _keyword);
        console.log("_endKey::: ", _endKey);
        console.log("typeof(_keyword)::: ", typeof _keyword);
        query = query
          .where(_searchField, ">=", _keyword)
          .where(_searchField, "<=", _endKey)
          .limit(pageLimit);
      }

      if (this.state.saleorders.fromDate) {
        const _searchField = new firebase.firestore.FieldPath(
          this.state.saleorders.searchField
        );

        console.log("_searchField:: ", _searchField);

        const _keyword = getDateBefore(this.state.saleorders.fromDate);

        if (this.state.saleorders.toDate) {
          const _endKey = getDateBeforeEnd(this.state.saleorders.toDate);
          console.log("dateKeyFrom::: ", _keyword);
          console.log("dateKeyTo::: ", _endKey);
          query = query
            .where(_searchField, ">=", _keyword)
            .where(_searchField, "<=", _endKey)
            .limit(pageLimit);
        } else {
          const _endKey = getDateEndPlus100Milliseconds(
            this.state.saleorders.fromDate
          );
          console.log("dateKeyFrom der::: ", _keyword);
          query = query
            .where(_searchField, ">=", _keyword)
            .where(_searchField, "<=", _endKey)
            .limit(pageLimit);
        }

        // console.log("date triggered");
      }

      if (
        this.state.saleorders.orderBySelect &&
        this.state.saleorders.orderBySelect["key"] &&
        this.state.saleorders.orderBySelect["key"] !== "ID" &&
        !keyword &&
        !this.state.saleorders.fromDate &&
        !this.state.saleorders.toDate
      ) {
        query = query.orderBy(
          new firebase.firestore.FieldPath(
            this.state.saleorders.orderBySelect["key"]
          ),
          this.state.saleorders.orderBySelect["value"]
        );
      }

      if (
        this.state.saleorders.valueFilterList.length > 0 &&
        (!keyword ||
          (!this.state.saleorders.fromDate && !this.state.saleorders.toDate))
      ) {
        let downloaded =
          this.state.saleorders.valueFilterList.includes("@DownloadedXml");
        let notDownload =
          this.state.saleorders.valueFilterList.includes("not-download");
        if (downloaded && !notDownload) {
          query = query.where("@DownloadedXml", "==", true);
        }
        if (notDownload && !downloaded) {
          query = query.where("@DownloadedXml", "==", false);
        }
      }

      // console.log("selectedBranch :: ", selectedBranch);
      // console.log("documentTypeNumber :: ", documentTypeNumber);
      // if (selectedBranch) {
      //   query = query.where("@SellerBranchID", "==", selectedBranch);
      // }

      // if (documentTypeNumber) {
      //   query = query.where("@DocType", "==", documentTypeNumber);
      // }

      // console.log(
      //   "this.state.saleorders.listOrigin::: ",
      //   this.state.saleorders.listOrigin
      // );

      if (
        this.state.saleorders.page > 1 &&
        this.state.saleorders.listOrigin.length !== 0
      ) {
        let listTmpPage;
        if (isNextPage) {
          listTmpPage =
            this.state.saleorders.stackPage[this.state.saleorders.page - 1];
          query = query.startAfter(listTmpPage["last"]).limit(pageLimit);
        } else {
          listTmpPage =
            this.state.saleorders.stackPage[this.state.saleorders.page];
          query = query.startAt(listTmpPage["first"]).limit(pageLimit);
        }
      } else if (pageLimit) {
        query = query.limit(pageLimit);
      }

      if (this.state.mSaleOrdersDocListUnsubscribeObject) {
        this.state.mSaleOrdersDocListUnsubscribeObject();
      }
      this.state.mSaleOrdersDocListUnsubscribeObject = query.onSnapshot(
        (documents) => {
          let documentsArray = [];

          if (documents.size !== 0) {
            for (const doc of documents.docs) {
              let document = doc.data();
              document.id = doc.id;
              documentsArray.push(document);
            }

            let startVisible = documents.docs[0];
            let lastVisible = documents.docs[documents.docs.length - 1];

            let objectTmp = {
              first: _.cloneDeep(startVisible),
              last: _.cloneDeep(lastVisible),
            };
            let stackPage = _.cloneDeep(this.state.saleorders.stackPage);
            stackPage[this.state.saleorders.page] = objectTmp;

            //If there is filter downloaded xml
            const { valueFilterList, orderBySelect } = this.state.saleorders;
            const downloaded = valueFilterList.includes("@DownloadedXml");
            const notDownload = valueFilterList.includes("not-download");

            if (
              downloaded &&
              !notDownload &&
              (keyword ||
                (this.state.saleorders.fromDate &&
                  this.state.saleorders.toDate))
            ) {
              documentsArray = this.state.saleorders.list.filter(
                (item) => item["@DownloadedXml"]
              );
            } else if (
              notDownload &&
              !downloaded &&
              (keyword ||
                (this.state.saleorders.fromDate &&
                  this.state.saleorders.toDate))
            ) {
              documentsArray = this.state.saleorders.list.filter(
                (item) => !item["@DownloadedXml"]
              );
            }

            if (
              orderBySelect &&
              orderBySelect.key &&
              orderBySelect.key !== "ID" &&
              (keyword ||
                this.state.saleorders.fromDate ||
                this.state.saleorders.toDate)
            ) {
              const { key, value } = orderBySelect;
              documentsArray = sortByField(documentsArray, key, value);
            }

            commit("setStackPage", stackPage);

            if (
              this.state.saleorders.page > 1 &&
              (keyword ||
                this.state.saleorders.fromDate ||
                this.state.saleorders.toDate)
            ) {
              // console.log("listOrigin :: ,", documentsArray);
              const { key, value } = orderBySelect;
              commit(
                "setCompaniesDocs",
                sortByField(
                  [...this.state.saleorders.list, ...documentsArray],
                  key,
                  value
                )
              );
            } else {
              commit("setCompaniesDocs", documentsArray);
            }

            // console.log("documentsArrayLLLLLLL ==> ", documentsArray);
            commit("setListOrigin", documentsArray);
            commit("setEmptyList", false);
          } else if (
            documents.size === 0 &&
            (keyword ||
              this.state.saleorders.fromDate ||
              this.state.saleorders.toDate) &&
            this.state.saleorders.page > 1
          ) {
            // console.log("document == 0 and have search");
            commit("setCompaniesDocs", [...this.state.saleorders.list]);
            commit("setListOrigin", []);
          } else {
            // console.log("document == 0 and dont have search");
            commit("setCompaniesDocs", []);
            commit("setListOrigin", []);
            commit("setEmptyList", true);
          }
          commit("setLoading", false);
        }
      );
    },
    getDocListUnsubscribe() {
      if (this.state.mSaleOrdersDocListUnsubscribeObject) {
        this.state.mSaleOrdersDocListUnsubscribeObject();
        this.state.mSaleOrdersDocListUnsubscribeObject = null;
      }
    },
    getListByMonth(
      { commit },
      { companyID, startDate, endDate, reportBranchType }
    ) {
      commit("setLoading", true);
      const fieldQuery = new firebase.firestore.FieldPath(
        "ED.IssueDateTime.Timestamp"
      );
      const docs = fc.companies.doc(companyID).collection("Docs");
      let query = docs;

      query = query.where("@DownloadedXml", "==", true);

      if (startDate && endDate) {
        query = query
          .where(fieldQuery, ">=", new Date(startDate))
          .where(fieldQuery, "<=", new Date(endDate));
      }

      if (reportBranchType) {
        query = query.where("@SellerBranchID", "==", reportBranchType);
      }

      query.get().then(function (docs) {
        let docList = [];
        let summary = {
          sumTaxableAmount: 0.0,
          sumTaxableTax: 0.0,
          sumTaxableAllAmount: 0.0,

          sumAmount: 0.0, // รวมมูลค่าสินค้าที่ไม่มีภาษี
          sumTax: 0.0, // รวมภาษีที่ไม่มีภาษี (เป็น 0 เสมอ)
          sumAllAmount: 0.0, // รวมยอดสุดท้ายที่ไม่มีภาษี

          grandTotalAmount: 0.0, // รวมมูลค่าสินค้าทั้งหมด
          grandTotalTax: 0.0, // รวมภาษีทั้งหมด
          grandTotalAllAmount: 0.0, // รวมยอดสุดท้ายทั้งหมด
        };
        docs.forEach((doc) => {
          let docData = doc.data();
          docData.id = doc.id;

          // case 4 ใบลดหนี้
          if (docData["@DocType"] === 4) {
            docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"] *= -1;
            docData["SCTT.AHTS.STSHMS.TaxTotalAmount"] *= -1;
            docData["SCTT.AHTS.STSHMS.GrandTotalAmount"] *= -1;
          }

          docList.push(docData);
          summary.grandTotalAmount +=
            docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"];
          summary.grandTotalTax += docData["SCTT.AHTS.STSHMS.TaxTotalAmount"];
          summary.grandTotalAllAmount +=
            docData["SCTT.AHTS.STSHMS.GrandTotalAmount"];
          if (
            docData["SCTT.AHTS.STSHMS.TaxTotalAmount"] &&
            docData["SCTT.AHTS.STSHMS.TaxTotalAmount"] !== "0"
          ) {
            summary.sumTaxableAmount +=
              docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"];
            summary.sumTaxableTax += docData["SCTT.AHTS.STSHMS.TaxTotalAmount"];
            summary.sumTaxableAllAmount +=
              docData["SCTT.AHTS.STSHMS.GrandTotalAmount"];
          } else {
            summary.sumAmount +=
              docData["SCTT.AHTS.STSHMS.TaxBasisTotalAmount"];
            summary.sumAllAmount +=
              docData["SCTT.AHTS.STSHMS.GrandTotalAmount"];
          }
        });
        commit("setDocList", docList);
        commit("setLoading", false);
        commit("setSummaryReport", summary);
      });
    },
    updatePage({ commit }, { page }) {
      commit("setPage", page);
    },
    updateKeyword({ commit }, { keyword }) {
      commit("setCurrentPageAlgolia", 0);
      commit("setKeyword", keyword);
    },
    resetKeyword({ commit }) {
      commit("setKeyword", "");
    },
    setOrderBySelect({ commit }, { orderBySelect }) {
      commit("setOrderBySelect", orderBySelect);
    },
    setValueFilterList({ commit }, { valueFilterList }) {
      commit("setValueFilterList", valueFilterList);
    },
    setSelectedList({ commit }, { selectedList }) {
      commit("setSelectedList", selectedList);
    },
    getSummaryAll({ commit }, { companyId }) {
      if (this.state.mSaleOrdersSummaryAllUnsubscribeObject) {
        this.state.mSaleOrdersSummaryAllUnsubscribeObject();
      }
      this.state.mSaleOrdersSummaryAllUnsubscribeObject = fc.companies
        .doc(companyId)
        .collection("Summaries")
        .doc("all")
        .onSnapshot(function (allSummaries) {
          console.log(allSummaries.data());
          commit("setSummaryAll", allSummaries.data());
        });
    },
    getSummaryAllUnsubscribe() {
      if (this.state.mSaleOrdersSummaryAllUnsubscribeObject) {
        this.state.mSaleOrdersSummaryAllUnsubscribeObject();
        this.state.mSaleOrdersSummaryAllUnsubscribeObject = null;
      }
    },
    setShowPaginationTemplate({ commit }, { val }) {
      commit("setShowPaginationTemplate", val);
    },
  },
};

export const docsQuery = gql`
  query docs(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $companyId: String!
    $order: String
    $search: String
    $issueDateTimeRange: [DateTime]
    $objectId: String
    $scttAhtaBtpId: String
    $buyerBranchId: String
    $typeLineTotal: String
    $lineTotal: [Float]
    $typeTaxTotal: String
    $taxTotal: [Float]
    $typeGrandTotal: String
    $grandTotal: [Float]
    $timeSignedXmlRange: [DateTime]
    $docType: String
    $downloadedXml: Boolean
    $signSuccess: Boolean
    $hasError: Boolean
    $mailSent: Boolean
    $suspendedAccount: Boolean
    $buyerEmail_Isnull: Boolean
  ) {
    docs: allDocument(
      first: $first
      after: $after
      last: $last
      before: $before
      companyId: $companyId
      order: $order
      search: $search
      issueDateTimeRange: $issueDateTimeRange
      objectId: $objectId
      scttAhtaBtpId: $scttAhtaBtpId
      buyerBranchId: $buyerBranchId
      typeLineTotal: $typeLineTotal
      lineTotal: $lineTotal
      typeTaxTotal: $typeTaxTotal
      taxTotal: $taxTotal
      typeGrandTotal: $typeGrandTotal
      grandTotal: $grandTotal
      timeSignedXmlRange: $timeSignedXmlRange
      docType: $docType
      downloadedXml: $downloadedXml
      signSuccess: $signSuccess
      hasError: $hasError
      mailSent: $mailSent
      suspendedAccount: $suspendedAccount
      buyerEmail_Isnull: $buyerEmail_Isnull
    ) {
      totalCount
      edgeCount
      edges {
        node {
          id
          docType
          objectId
          edIssueDateTime
          scttAhtaBtpId
          scttAhtaBtpName
          scttAhtaBtpStrId
          buyerBranchId
          scttAhtsStshmsTaxBasisTotalAmount
          scttAhtsStshmsTaxTotalAmount
          scttAhtsStshmsGrandTotalAmount
          timeSignedXml
          mailSent
          downloadedXml
          signedXmlUrl
          signedPdfUrl
          unsignedPdfUrl
          errors
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
